import header_menu from '../ui/header_menu';
let headerMenuInit = false;
document.addEventListener("turbo:load", () => {
    if(!headerMenuInit){
    header_menu.init('.menu', '.toggle', 'has-menu-submenu', '.has-menu-submenu', 
    '.submenu-parent', '.active', '.menu-submenu-active', 
    '.menu-submenu', '.menu-item');
    }
    headerMenuInit = true;
});